import throttle from 'lodash/throttle';
import { Controller } from 'stimulus';

export default class extends Controller {
  initialize() {
    this.headerDrawer = document.querySelector('.js-header-drawer');
    this.hamburgerToggle = document.querySelectorAll('.js-hamburger-toggle');
    this.navItems = document.querySelectorAll('.js-nav-items a');
    this.subnavToggle = document.querySelector('.js-subnav-toggle');
    this.hamburgerToggle.forEach((el) => {
      el.addEventListener('click', this.toggleMobileMenu.bind(this));
    });
    this.navItems.forEach((el) => {
      el.addEventListener('click', this.closeDrawer.bind(this));
    });
    this.subnavToggle.addEventListener('click', this.toggleSubnav.bind(this));
    window.addEventListener('scroll', throttle(this.pagescroll, 250));
    window.addEventListener(
      'resize',
      throttle(() => {
        if (window.location.hash) {
          this.smoothScrollToAnchor(window.location.hash);
        }
      }, 250)
    );
  }

  handlePageLoad() {
    const hash = window.location.hash;
    if (hash) {
      this.smoothScrollToAnchor(hash);
    }
  }

  smoothScrollToAnchor(selector) {
    const targetElement = document.querySelector(selector);
    if (targetElement) {
      setTimeout(() => {
        targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 200);
    }
  }

  closeDrawer() {
    this.headerDrawer.classList.remove('open');
    this.hamburgerToggle.forEach((el) => {
      el.classList.remove('open');
      el.setAttribute('aria-expanded', false);
    });
    document.body.classList.remove('-is-scroll-locked');
  }

  toggleMobileMenu() {
    this.headerDrawer.classList.toggle('open');
    let isOpen = this.headerDrawer.classList.contains('open');
    this.hamburgerToggle.forEach((el) => {
      el.classList.toggle('open');
      el.setAttribute('aria-expanded', isOpen);
    });
    document.body.classList.toggle('-is-scroll-locked', isOpen);
  }

  toggleSubnav(e) {
    let toggle = e.target;
    if (!toggle.classList.contains('cta--nav-link')) {
      toggle = toggle.parentElement;
    }
    let subnav = toggle.nextElementSibling;

    toggle.classList.toggle('open');
    subnav.classList.toggle('open');
    toggle.setAttribute('aria-expanded', (index, attr) => {
      return attr == 'true' ? 'false' : 'true';
    });

    if (toggle.classList.contains('open')) {
      this.element.style.paddingBottom = subnav.clientHeight + 'px';
    } else {
      this.element.style.paddingBottom = '0px';
    }
  }

  pagescroll() {
    let body = document.body;
    let header = document.querySelector('#header-main');
    let footer = document.querySelector('footer.site-footer');
    let viewport = {
      top: window.scrollY,
      bot: window.scrollY + window.innerHeight,
    };

    // Page has started scrolling
    let isScrolling = viewport.top > 5;
    body.classList.toggle('-page-scrolling', isScrolling);
    header.classList.toggle('-page-scrolling', isScrolling);

    // Page is at the bottom near the footer
    let nearBottom = viewport.bot > footer.offsetTop;
    body.classList.toggle('-page-bottom', nearBottom);
  }
}
